import { type FC } from "react";

import { useVideoControls } from "../hooks";

interface VideoViewerProps {
    src: string;
    width?: string;
    height?: string;
    className?: string;
    handleError?: () => void;
    autoplay?: boolean;
    ref?: React.MutableRefObject<HTMLVideoElement | null>;
}

export const VideoViewer: FC<VideoViewerProps> = ({
    src,
    autoplay,
    width = "100%",
    height = "100%",
    className = "",
    handleError,
}) => {
    const { togglePlaying, videoRef } = useVideoControls(src);

    return (
        <>
            <video
                width={width}
                height={height}
                loop={true}
                autoPlay={autoplay}
                muted={true}
                onClick={togglePlaying}
                ref={videoRef}
                className={className}
                onError={handleError}
            >
                <source src={src} />
            </video>
        </>
    );
};
